var render = function render(){var _vm=this,_c=_vm._self._c;return _c('response-dialog',{attrs:{"model":_vm.model,"message":_vm.message,"type":_vm.type},on:{"update:model":function($event){_vm.model=$event},"close":function($event){return _vm.close()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }